import styled from "styled-components";

export const TelaInicialWrapper = styled.div`

`